function slideToggle(element, duration = 300) {
  if (!element) return;
  if (window.getComputedStyle(element).display === 'none') {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;
    const height = element.scrollHeight;

    element.style.overflow = 'hidden';
    element.style.height = '0px';
    element.offsetHeight; 
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  } else {
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    element.offsetHeight; 
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = '0px';

    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }
}

document.querySelectorAll('.js-open-collection-filter').forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    const topFilter = document.querySelector('.js-top-filter');

    if (window.outerWidth > 991) {
      btn.classList.toggle('active');
      slideToggle(topFilter, 300);
    } else {
      document.querySelectorAll('.js-open-mobile-filter, .js-close-filter').forEach(function (el) {
        el.classList.toggle('active');
      });
      topFilter?.classList.toggle('active');
      document.body.classList.toggle('overflow-hidden');
      e.preventDefault();
    }
  });
});

document.querySelectorAll('.js-open-mobile-filter, .js-close-filter').forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    document.querySelectorAll('.js-open-mobile-filter, .js-close-filter').forEach(function (el) {
      el.classList.toggle('active');
    });
    document.querySelector('.js-top-filter')?.classList.toggle('active');
    document.body.classList.toggle('overflow-hidden');
    e.preventDefault();
  });
});

window.addEventListener('scroll', function () {
  const nextPageEl = document.querySelector('.js-collection-next-page');

  if (nextPageEl) {
    const scrollTop = window.scrollY;
    const nextPageOffsetTop = nextPageEl.getBoundingClientRect().top + window.scrollY;
    const windowHeight = window.innerHeight;

    if (scrollTop > nextPageOffsetTop - windowHeight - 100) {
      const href = nextPageEl.getAttribute('data-href');
      document.querySelectorAll('.js-collection-pagination').forEach(el => {
        el.classList.remove('js-collection-next-page');
      });

      fetch(href, { method: 'GET' })
        .then(response => response.text())
        .then(data => {
          document.querySelectorAll('.js-collection-pagination').forEach(el => el.remove());
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data;
          const newContent = tempDiv.querySelector('.js-collection-row');
          if (newContent) {
            document.querySelector('.js-collection-row').insertAdjacentHTML('beforeend', newContent.innerHTML);
          }
          
          if (typeof initializeFadeInObserver === 'function') {
            initializeFadeInObserver();
          }

          if (typeof wishlistPage === "function") {
            wishlistPage();
          }

          if (typeof initProductGridItemColors === "function") {
            initProductGridItemColors();
          }
        });
    }
  }
});

document.body.addEventListener('click', function (e) {
  const target = e.target.closest('.js-collection-load-more');
  if (target) {
    e.preventDefault();

    target.innerHTML = target.getAttribute('data-loading-text');
    const href = target.getAttribute('data-href');

    fetch(href, { method: 'GET' })
      .then(response => response.text())
      .then(data => {
        target.closest('.col-12')?.remove();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data;
        const newContent = tempDiv.querySelector('.js-collection-row');
        if (newContent) {
          document.querySelector('.js-collection-row').insertAdjacentHTML('beforeend', newContent.innerHTML);
        }

        if (typeof initializeFadeInObserver === 'function') {
          initializeFadeInObserver();
        }

        if (typeof wishlistPage === "function") {
          wishlistPage();
        }

          if (typeof initProductGridItemColors === "function") {
            initProductGridItemColors();
          }
      });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-collection-with-sidebar") && window.innerWidth > 991) {
    const sidebarContent = document.querySelector(".js-left-sidebar-content");
    const facets = document.querySelector("collection-facets");

    if (sidebarContent && facets) {
      sidebarContent.appendChild(facets);
      sidebarContent.classList.remove("d-none");
    }

    const backSidebarTop = document.querySelector(".js-get-back-sidebar-filter-top");
    if (sidebarContent && backSidebarTop) {
      const sortAndView = sidebarContent.querySelector(".collection__sort-and-view");
      const foundedProducts = sidebarContent.querySelector(".collection__founded-products");

      if (sortAndView) {
        const cloneSort = sortAndView.cloneNode(true);
        backSidebarTop.appendChild(cloneSort);
        syncSelects(cloneSort, sortAndView);
      }

      if (foundedProducts) {
        const cloneFounded = foundedProducts.cloneNode(true);
        backSidebarTop.appendChild(cloneFounded);
        syncSelects(cloneFounded, foundedProducts);
      }
    }
  }

  function syncSelects(cloneBlock, originalBlock) {
    const cloneSelects = cloneBlock.querySelectorAll("select");
    const originalSelects = originalBlock.querySelectorAll("select");

    cloneSelects.forEach((cloneSelect, index) => {
      const originalSelect = originalSelects[index];
      if (!originalSelect) return;

      cloneSelect.addEventListener("change", () => {
        originalSelect.value = cloneSelect.value;

        originalSelect.dispatchEvent(new Event("input", { bubbles: true }));
        originalSelect.dispatchEvent(new Event("change", { bubbles: true }));
        originalSelect.dispatchEvent(new Event("blur", { bubbles: true }));
      });
    });
  }
});